import { Game } from "../../game.js";
import { IHighlightRect } from "./abstract_tutorial_highlight.js";
import { ColorScheme } from "./color_scheme.js";
import { UIElement } from "./ui_element.js";

export class TutorialSpotlight extends UIElement
{
  private static readonly SOFT_EDGE_RATIO = 0.4;

  private readonly target: IHighlightRect;
  private readonly radius_scale: number;

  constructor( ctx: CanvasRenderingContext2D, width: number, height: number, target: IHighlightRect, radius_scale: number )
  {
    super( ctx, 0, 0, width, height, false, false );

    this.target = target;
    this.radius_scale = radius_scale;
    this.setClickable( false );
  }

  public render(): void
  {
    if ( !this.shouldBeRendered() )
    {
      this.skipRenderSubtree();
      return;
    }

    this.startRender();

    const ctx = this.ctx;
    const origin = this.getAbsolutePosition();
    const w2 = this.rect.getW2();
    const h2 = this.rect.getH2();
    const cx = this.target.x + this.target.width / 2 - w2;
    const cy = this.target.y + this.target.height / 2 - h2;
    const inner = Math.hypot( this.target.width / 2, this.target.height / 2 ) * this.radius_scale;
    const outer = inner * ( 1 + TutorialSpotlight.SOFT_EDGE_RATIO );
    const inner_stop = inner / outer;

    const gradient = ctx.createRadialGradient( cx, cy, 0, cx, cy, outer );
    gradient.addColorStop( 0, ColorScheme.tutorial_spotlight_clear );
    gradient.addColorStop( inner_stop, ColorScheme.tutorial_spotlight_clear );
    gradient.addColorStop( 1, ColorScheme.tutorial_spotlight_dim );

    ctx.fillStyle = gradient;
    ctx.fillRect( -w2 - origin.x, -h2 - origin.y, Game.screenW(), Game.screenH() );

    this.finishRender();
  }

  public name(): string
  {
    return "TutorialSpotlight";
  }
}
